import { API, handleApiError } from "./utils";

const path = "integrations";

export const getRevenueByMember = async ({
  organisationId,
  startDate,
  endDate,
  search,
  page,
  pageSize,
} = {}) => {
  try {
    const res = await API.get(`/${path}/analytics/revenue-by-member`, {
      params: {
        organisationId,
        ...(startDate && { startDate }),
        ...(endDate && { endDate }),
        ...(search && { search }),
        ...(page && { page }),
        ...(pageSize && { pageSize }),
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getRevenueByGroup = async ({
  organisationId,
  startDate,
  endDate,
  search,
  page,
  pageSize,
} = {}) => {
  try {
    const res = await API.get(`/${path}/analytics/revenue-by-group`, {
      params: {
        organisationId,
        ...(startDate && { startDate }),
        ...(endDate && { endDate }),
        ...(search && { search }),
        ...(page && { page }),
        ...(pageSize && { pageSize }),
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getGroupTransactions = async ({
  organisationId,
  groupId,
  startDate,
  endDate,
  page,
  pageSize,
} = {}) => {
  try {
    const res = await API.get(`/${path}/analytics/revenue-by-group/transactions`, {
      params: {
        organisationId,
        groupId,
        ...(startDate && { startDate }),
        ...(endDate && { endDate }),
        ...(page && { page }),
        ...(pageSize && { pageSize }),
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};
